import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import countries from 'country-calling-code';
var UsaStates = require('usa-states').UsaStates;
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class PublicationTitleInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      prevPage: 'singe',
      states: [],
    };
  }

  componentDidMount() {
    const usStates = new UsaStates();
    let { states } = usStates;
    states = [{ abbreviation: 'Non-U.S.' }, ...states];
    this.setState({
      prevPage: this.props.params.prevPage,
      states,
    });
  }

  handleTitleType(e, key) {
    const { fields } = this.props;

    let titleTypes = fields.titleTypes || {};
    titleTypes[key] = e.target.value;

    this.props.assignAttribute('titleTypes', { ...titleTypes });
  }

  handleNext() {
    this.props.hideAlert();
    const { fields } = this.props;
    const titleTypes = fields.titleTypes || {};
    let checked = true;

    if (!titleTypes.titleOfPublication || !titleTypes.state || !titleTypes.nationOfPublication) {
      checked = false;
    }

    if (checked) {
      this.props.assignAttribute('workType', this.state.prevPage);
      this.props.router.push('/publication-reg/provide-url');
    } else {
      this.props.alert('error', 'Please check the required fields.');
    }
  }

  handleBack() {
    this.props.router.goBack();
  }

  render() {
    const { states } = this.state;
    const { fields } = this.props;
    const titleTypes = fields.titleTypes || {};

    return (
      <div className="select-work work-title">
        <Heading text="Tell Us More About This Publication" />
        <div className="content">
          <Form>
            <FormGroup>
              <ul>
                <li>
                  <div>
                    <span className="text-red">*</span>Title of Publication:
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.titleOfPublication || ''}
                    onChange={(e) => this.handleTitleType(e, 'titleOfPublication')}
                    placeholder="Type Here"
                  />
                </li>
                <li>
                  <div>
                    <span className="text-red">*</span>State:
                  </div>
                  <FormControl
                    componentClass="select"
                    value={titleTypes.state || -1}
                    onChange={(e) => this.handleTitleType(e, 'state')}
                  >
                    <option disabled key={-1} value={-1}>
                      Select
                    </option>
                    {states.map((item, i) => (
                      <option key={i} value={item.abbreviation}>
                        {item.abbreviation}
                      </option>
                    ))}
                  </FormControl>
                </li>
                <li>
                  <div>
                    <span className="text-red">*</span>Nation of Publication:
                  </div>
                  <FormControl
                    componentClass="select"
                    value={titleTypes.nationOfPublication || -1}
                    onChange={(e) => this.handleTitleType(e, 'nationOfPublication')}
                  >
                    <option disabled key={-1} value={-1}>
                      Select Country
                    </option>
                    {countries.map((country, i) => (
                      <option key={i} value={country.country}>
                        {country.country}
                      </option>
                    ))}
                  </FormControl>
                </li>
                <li>
                  <div>ISSN:</div>
                  <FormControl
                    type="text"
                    value={titleTypes.issn || ''}
                    onChange={(e) => this.handleTitleType(e, 'issn')}
                    placeholder="Type Here"
                  />
                </li>
              </ul>
            </FormGroup>
          </Form>
        </div>
        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handleBack()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationTitleInformation);



// WEBPACK FOOTER //
// src/components/Publication/PublicationTitleInformation.jsx